import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

interface IToolEditContext {
    isLoading: boolean
    tool: Tool
    saveTool: (tool: Tool) => void
    goBack: () => void
}

export interface User {
    value: string
    label: string
}

export let toolSchema = yup.object().shape({
    toolId: yup.string().nullable().default(''),
    toolTypologyId: yup.string().required().default('').label('Tipologia'),
    serialNumber: yup.string().nullable().default('').label('Seriale'),
    name: yup.string().required().default('').label('Nome'),
    notes: yup.string().nullable().default('').label('Note')
});

type Tool = yup.InferType<typeof toolSchema>;

export let toolEditContext = React.createContext({} as IToolEditContext);

let { Provider } = toolEditContext;

let ToolEditProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [tool, setTool] = useState<Tool>(toolSchema.getDefault());


    useEffect(() => {
        if (isNew === false)
            getTool()
            
    }, [id, isNew])

    let getTool = async () => {
        try {
            let res = await axios.get('/api/Tool/GetTool', { params: { toolId: id } });

            let { item } = res.data;
            setTool(item);
            
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveTool = async (value: Tool) => {
        if (window.confirm("Vuoi salvare questo Strumento?")) 
        try {
            let response = await axios.post('/api/Tool/SaveTool', value);
            enqueueSnackbar("Tool saved", { variant: "success" });
            
            let { id } = response.data;
            if (isNew) {
                if (id != null) {
                    history.push(`/tool/` + response.data.id);
                } else {
                    history.push(`/tools`);
                }
            } else {
                goBack();
            }

        } catch (err) {
        }
    }

    let goBack = () => {
        history.goBack()
    }


    return (
        <Provider
            value={{
                isLoading,
                tool,

                saveTool,
                goBack
            }}
        >
            {children}
        </Provider>
    )
}

export default ToolEditProvider;